import { z } from 'zod';

export * from './phone.js';

export const PaginationSchema = z.object({
    page: z.number().default(1),
    limit: z.number().default(10),
    search: z.string().optional(),
    sortBy: z.string().optional(),
    order: z.enum(['asc', 'desc']).default('desc'),
});

export const ApiResponseSchema = (dataSchema) => z.object({
    success: z.boolean(),
    data: dataSchema.optional(),
    error: z.string().optional(),
    meta: z.object({
        page: z.number(),
        total: z.number(),
        totalPages: z.number(),
    }).optional()
});
